module.exports = __webpack_public_path__ + "static/media/close_icon_mobile.6b7471e4.svg";